import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { useHistory } from 'react-router';
import { redirect, exportDocument } from '../../helpers';

const TitleCard = (props) => {
  let history = useHistory();
  const { image, imageRedirect, tipRedirect, tip } = props;

  return (
    <div className='py-3'>
      <div className='row my-3'>
        <div className='col-md-6'>
          <Paper
            href={imageRedirect}
            elevation={0}
            className='bg-light p-0'
            onClick={() => exportDocument(imageRedirect)}
            target='_blank'
            style={{
              overflow: 'hidden',
              maxHeight: '100%',
            }}
          >
            <img
              src={image}
              className='img-fluid rounded-sm'
              alt={image}
              style={{
                backgroundColor: 'rgba(238,238,238,255)',
                maxWidth: '100%',
                maxHeight: '200%',
                paddingBottom: 20,
                margin: 0,
              }}
            />
          </Paper>
        </div>
        <div className='col-md-6 rounded-sm'>
          {tip ? (
            <Paper
              href={tipRedirect}
              elevation={0}
              className='bg-light p-0'
              onClick={() => exportDocument(tipRedirect)}
              target='_blank'
              style={{
                overflow: 'hidden',
                maxHeight: '100%',
              }}
            >
              <img
                src={tip}
                className='img-fluid rounded-sm'
                alt={tip}
                style={{
                  backgroundColor: 'rgba(238,238,238,255)',
                  maxWidth: '100%',
                  maxHeight: '200%',
                  padding: 0,
                  margin: 0,
                }}
              />
            </Paper>
          ) : null}
        </div>
      </div>
    </div>
  );
};

TitleCard.propTypes = {
  image: PropTypes.string,
  imageRedirect: PropTypes.string,
  tipRedirect: PropTypes.string,
  tip: PropTypes.string,
};

export default TitleCard;
